<template>
  <div class="progress-bar" v-show="show">
    <div class="progress" :style="{
          width: progress + '%'
        }">
      {{ progress }}%
    </div>
  </div>
</template>
<script>
export default {
  //   props: { progress: { type: Number, default: 0 } },
  data() {
    return {
      progress: 0,
      show: false,
    }
  },
  methods: {
    updateProgress(newValue) {
      this.progress = newValue
    },
    updateShow(newValue) {
      this.show = newValue
    },
  },
}
</script>
<style lang="less" scoped>
.progress-bar {
  width: 100%;
  height: 30px;
  color: #000;
  text-align: center;
  line-height: 30px;
  box-sizing: border-box;
  position: relative;
  top: 40%;
  border: 1px solid rgb(226, 226, 226);
  border-radius: 15px;
  // box-shadow: -1px -1px 1px #000;
  background: rgb(255, 255, 255);
  position: relative;
  .progress {
    height: 100%;
    background: #57a3f3;
    color: #fff;
    border-radius: 15px;
    overflow: hidden;
    position: absolute;
    opacity: 0.8;
    text-align: center;
  }
}
</style> 